import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export interface SEOContentBlockProps {
  eyebrow?: string;
  heading: string;
  paragraphs: string[];
  links?: { label: string; to: string }[];
  className?: string;
}

export const SEOContentBlock = ({
  eyebrow,
  heading,
  paragraphs,
  links,
  className,
}: SEOContentBlockProps) => {
  return (
    <section
      className={cn("bg-muted/30 border-t border-border/50", className)}
      aria-label="About this experience"
    >
      <div className="container-narrow mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          {eyebrow && (
            <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold mb-3">
              {eyebrow}
            </p>
          )}
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-5 leading-tight">
            {heading}
          </h2>
          <div className="space-y-4 text-muted-foreground text-base leading-relaxed">
            {paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          {links && links.length > 0 && (
            <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 text-sm">
              {links.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="text-primary hover:underline font-medium"
                >
                  {link.label} →
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
